import { Lightning } from "@phosphor-icons/react";
import { useTranslation } from "@/contexts/LanguageContext";

export default function PracticeStreakBadge({ count, testId = "practice-streak-badge", size = "sm" }) {
  const { lang } = useTranslation();
  if (!count) return null;
  const big = size === "lg";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border border-sky-400/40 bg-sky-400/10 text-sky-300 font-medium ${big ? "px-3.5 py-1.5 text-sm" : "px-2.5 py-1 text-xs"}`}
      title={lang === "es" ? "Veces que despejaste todas tus preguntas falladas" : "Times you cleared all your missed questions"}
      data-testid={testId}
    >
      <Lightning weight="fill" className={big ? "w-4 h-4" : "w-3.5 h-3.5"} />
      {lang === "es" ? "Racha de Práctica" : "Practice Streak"} <span className="font-['JetBrains_Mono']">×{count}</span>
    </span>
  );
}
